import React from 'react';
import { Media } from 'reactstrap';
import { Btn, Image } from '../../AbstractElements';
import { useNavigate } from 'react-router-dom';

const style2 = { width: 60, fontSize: 14, padding: 4 };
export const Navigator = ({to,params}) => {
    const navigate = useNavigate();
    // console.log('returned') 
    const handleNavigation = () => {
        navigate(to,{ state: params });
        // navigate(`${to}/${action}`);
      };
    // return <Navigate exact to={`${process.env.PUBLIC_URL}/patientList`}  navigate(`${process.env.PUBLIC_URL}/patientList/:layout`)/>
    return (
        <Btn attrBtn={{ style: style2, color: 'success', className: 'btn btn-xs', type: 'button', onClick: handleNavigation}}>{params? params.btn : "Edit"} </Btn>)
       
}

const PatientPage = ({to, name}) => {
    const navigate = useNavigate();
    // console.log('returned') 
    const handleNavigation = () => {
        navigate(to);
        // navigate(`${to}/${action}`);
      };
    // return <Navigate exact to={`${process.env.PUBLIC_URL}/patientList`}  navigate(`${process.env.PUBLIC_URL}/patientList/:layout`)/>
    return (
       <div className="f-w-700 font-success" onClick={handleNavigation} style={{cursor:'pointer'}}>{name}</div>)
       
}
export const dummytabledata = [
    {
        id: 1,
        name: 
        // <Media className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: `${user1}`, alt: 'Generic placeholder image' }} />
            <Media body className="align-self-center">
                <PatientPage to={`${process.env.PUBLIC_URL}/patientinfo/:layout`} name={"Hashira"}/>
                {/* <div className="f-w-700 font-success">Airi Satou</div>  */}
            </Media>,
        // {/* </Media>, */}
        date: '2023/04/27',
        regno: '#PX0101',
        // designation: 'System Architect',
        contactnumber: <span className="f-w-700"><i className="icofont"></i> 9988776655</span>,
        gender: 'Male',
        action: <span> <Navigator to={`${process.env.PUBLIC_URL}/patientForm/:layout`}/>
        {/* <Btn attrBtn={{ style: style2, color: 'success', className: 'btn btn-xs', type: 'button', onClick: Navigator }}>Edit </Btn> */}
      </span>
        // budget: '$3142.00',

    },
];

export const tableColumns = [
    {
        name: '#',
        selector: row => row['id'],
        sortable: true,
        center: false,
    },
    {
        name: 'Name',
        selector: row => row['name'],
        sortable: true,
        center: false,
    },
    {
        name: 'Date',
        selector: row => `${row.date}`,
        sortable: true,
        center: true,
    },
    {
        name: 'Reg No.',
        selector: row => `${row.regno}`,
        sortable: true,
        center: true,
    },
    {
        name: 'Contact Number',
        selector: row => row['contactnumber'],
        sortable: true,
        center: true,
    },
    {
        name: 'Gender',
        selector: row => `${row.gender}`,
        sortable: true,
        center: true,
    },
    {
        name: 'Action',
        selector: row => row['action'],
        sortable: false,
        center: true,
    },
];